import { NextSeo } from 'next-seo'
import { useQuery } from '@tanstack/react-query'
import Head from 'next/head'

import { EasyToEmplement } from 'sections/homesellers/easy-to-implement'
import { EdgeInSelling } from 'sections/homesellers/edge-in-selling'
import { Reviews } from 'sections/homesellers/reviews/Reviews'
import { ThingsToKnow } from 'sections/homesellers/things-to-know'
import { CustomWelcomeSection } from 'sections/homesellers/custom-welcome-section'
import { IncludePrice } from 'sections/homesellers/include-price'
import { QUERY_KEY } from 'const/query'
import { strapi } from 'api'

import welcomeImage from './images/welcome-homesellers.png'
import classes from './homeseller.module.css'
import { listItemsArr, welcomeSectionData } from './consts'

export default function Page() {
  const { data, isLoading } = useQuery([QUERY_KEY.thingsToKnow], () =>
    strapi.thingsToKnow.getThingsToKnow(),
  )

  const thingsToKnowData = data?.data

  return (
    <>
      <NextSeo title="Secure Your Home's Value - Home Price Protection for Sellers" />
      <Head>
        <meta
          name="keywords"
          content="Home Price Protection, Real Estate Value Maximization, Secure Home Selling, Competitive Home Listing, Market-Proof Home Selling, Real Estate Investment Protection, Top Dollar Home Sale, Innovative Home Selling Strategy, Home Value Safeguard, Attractive Home Listing, Real Estate Market Edge, Home Selling Confidence, High-Value Property Sale, Unique Selling Proposition Home, Home Sale Price Security, Home Selling Advantage, Property Value Protection, Enhanced Home Sale Offer, Market Resilient Home Selling"
        />
      </Head>
      <CustomWelcomeSection
        {...welcomeSectionData}
        image={welcomeImage.src}
        withBgSun={false}
        altText="Sign in front of protected house"
      >
        <ul className={classes.list}>
          {listItemsArr.map(({ highlighted, mainText }) => (
            <li key={highlighted}>
              <b>{highlighted}</b>
              {mainText}
            </li>
          ))}
        </ul>
      </CustomWelcomeSection>
      <EasyToEmplement />
      <IncludePrice />
      <EdgeInSelling />
      {/* <Reviews /> hidden acc to Ryans comment, will be shown weeks later */}
      {!isLoading && thingsToKnowData && Array.isArray(thingsToKnowData) && (
        <ThingsToKnow thingsToKnow={thingsToKnowData} />
      )}
    </>
  )
}
